export const clientFormTranslations = {
  pl: {
    // Navigation
    backButton: 'Powrót',
    editingClient: 'Edycja danych',
    saveButton: 'Zapisz',
    saveAndExitButton: 'Zapisz i wyjdź',
    saveButtonSaving: 'Zapisywanie...',
    saveAndExitButtonSaving: 'Zapisywanie...',
    cancelButton: 'Anuluj',

    // Success/Error messages
    updateSuccess: 'Dane klienta zostały zaktualizowane',
    updateError: 'Błąd podczas aktualizacji danych klienta',

    // Section headers
    basicInfo: 'Dane podstawowe',
    personalDetails: 'Dane osobowe',
    documents: 'Dokumenty tożsamości',
    addressInfo: 'Informacje adresowe',
    bankInfo: 'Dane bankowe',
    additionalInfo: 'Informacje dodatkowe',

    // Basic info fields
    firstName: 'Imię',
    firstNameRequired: 'Imię *',
    lastName: 'Nazwisko',
    lastNameRequired: 'Nazwisko *',
    email: 'Email',
    emailRequired: 'Email *',
    phone: 'Telefon',
    phoneCountryCode: 'Kod kierunkowy',
    mobile: 'Telefon komórkowy',
    mobileCountryCode: 'Kod kierunkowy',
    company: 'Firma',

    // Personal details
    gender: 'Płeć',
    male: 'Mężczyzna',
    female: 'Kobieta',
    dateOfBirth: 'Data urodzenia',
    placeOfBirth: 'Kraj urodzenia',
    nationality: 'Narodowość',
    isForeigner: 'Obcokrajowiec',
    pesel: 'PESEL',
    peselAssignmentDate: 'Data nadania numeru PESEL',
    peselAssignmentNote: 'dotyczy wyłącznie cudzoziemców',
    nip: 'NIP',
    businessName: 'Nazwa firmy',

    // Documents
    idCard: 'Numer dowodu osobistego',
    passportId: 'Numer paszportu',
    passportCountry: 'Kraj wydania paszportu',
    foreignIdCard: 'Zagraniczny dokument tożsamości',
    residenceCardNumber: 'Numer karty pobytu',
    residenceCardExpiryDate: 'Data wygaśnięcia karty pobytu',
    documentsNote: 'Wymagany jest numer dowodu osobistego lub paszportu (wystarczy jeden dokument)',

    // Address info
    mainAddress: 'Adres zamieszkania / zameldowania (może być zagraniczny)',
    correspondenceAddress: 'Adres do doręczeń w trakcie trwania umowy (może być w R4R)',
    billingAddress:
      'Adres do doręczeń po zakończeniu umowy (musi być w Polsce, nie może być w R4R, może być np. adres pracy)',
    street: 'Ulica',
    city: 'Miasto',
    zipcode: 'Kod pocztowy',
    country: 'Kraj',
    copyFromMain: 'Kopiuj z głównego',
    addressCopied: 'Adres został skopiowany',

    // Bank info
    iban: 'Numer konta IBAN',
    foreignAccountNumber: 'Numer rachunku zagranicznego',
    swift: 'Kod SWIFT',
    bankName: 'Nazwa banku',
    accountTypeIban: 'Rachunek IBAN (Europa)',
    accountTypeForeign: 'Rachunek zagraniczny',
    accountType: 'Typ rachunku',

    // Additional info
    description: 'Opis',
    language: 'Język komunikacji',
    employmentSector: 'Sektor zatrudnienia',
    employmentForm: 'Forma zatrudnienia',

    // Sensitive data indicators
    dataSet: 'W bazie',
    dataNotSet: 'Brak w bazie',

    // Validation messages
    firstNameMinLength: 'Imię musi mieć co najmniej 2 znaki',
    firstNameMaxLength: 'Imię może mieć maksymalnie 50 znaków',
    firstNameRequiredValidation: 'Imię jest wymagane',
    lastNameMinLength: 'Nazwisko musi mieć co najmniej 2 znaki',
    lastNameMaxLength: 'Nazwisko może mieć maksymalnie 50 znaków',
    lastNameRequiredValidation: 'Nazwisko jest wymagane',
    emailInvalid: 'Nieprawidłowy format email',
    emailRequiredValidation: 'Email jest wymagany',
    phoneInvalid: 'Nieprawidłowy format numeru telefonu',
    mobileInvalid: 'Nieprawidłowy format numeru telefonu',
    peselInvalid: 'PESEL musi mieć 11 cyfr',
    nipInvalid: 'NIP musi mieć 10 cyfr',
    ibanInvalid: 'Nieprawidłowy format IBAN'
  },
  en: {
    // Navigation
    backButton: 'Back',
    editingClient: 'Editing client data',
    saveButton: 'Save',
    saveAndExitButton: 'Save and exit',
    saveButtonSaving: 'Saving...',
    saveAndExitButtonSaving: 'Saving...',
    cancelButton: 'Cancel',

    // Success/Error messages
    updateSuccess: 'Client data has been updated',
    updateError: 'Error updating client data',

    // Section headers
    basicInfo: 'Basic Information',
    personalDetails: 'Personal Details',
    documents: 'Identity Documents',
    addressInfo: 'Address Information',
    bankInfo: 'Bank Information',
    additionalInfo: 'Additional Information',

    // Basic info fields
    firstName: 'First Name',
    firstNameRequired: 'First Name *',
    lastName: 'Last Name',
    lastNameRequired: 'Last Name *',
    email: 'Email',
    emailRequired: 'Email *',
    phone: 'Phone',
    phoneCountryCode: 'Country Code',
    mobile: 'Mobile Phone',
    mobileCountryCode: 'Country Code',
    company: 'Company',

    // Personal details
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    dateOfBirth: 'Date of Birth',
    placeOfBirth: 'Country of Birth',
    nationality: 'Nationality',
    isForeigner: 'Foreigner',
    pesel: 'PESEL',
    peselAssignmentDate: 'PESEL Assignment Date',
    peselAssignmentNote: 'applies to foreigners only',
    nip: 'NIP',
    businessName: 'Business Name',

    // Documents
    idCard: 'ID Card Number',
    passportId: 'Passport Number',
    passportCountry: 'Passport Issuing Country',
    foreignIdCard: 'Foreign ID Card',
    residenceCardNumber: 'Residence Card Number',
    residenceCardExpiryDate: 'Residence Card Expiry Date',
    documentsNote: 'ID card number or passport number is required (one document is sufficient)',

    // Address info
    mainAddress: 'Residential / Registered address (can be abroad)',
    correspondenceAddress: 'Address for correspondence during the contract period (can be in R4R)',
    billingAddress:
      'Address for correspondence after the contract ends (must be in Poland, cannot be in R4R, can be, for example, a work address)',
    street: 'Street',
    city: 'City',
    zipcode: 'Zipcode',
    country: 'Country',
    copyFromMain: 'Copy from main',
    addressCopied: 'Address has been copied',

    // Bank info
    iban: 'IBAN Account Number',
    foreignAccountNumber: 'Foreign Account Number',
    swift: 'SWIFT Code',
    bankName: 'Bank Name',
    accountTypeIban: 'IBAN Account (Europe)',
    accountTypeForeign: 'Foreign Account',
    accountType: 'Account Type',

    // Additional info
    description: 'Description',
    language: 'Communication Language',
    employmentSector: 'Employment Sector',
    employmentForm: 'Employment Form',

    // Sensitive data indicators
    dataSet: 'In database',
    dataNotSet: 'Not in database',

    // Validation messages
    firstNameMinLength: 'First name must be at least 2 characters',
    firstNameMaxLength: 'First name can be maximum 50 characters',
    firstNameRequiredValidation: 'First name is required',
    lastNameMinLength: 'Last name must be at least 2 characters',
    lastNameMaxLength: 'Last name can be maximum 50 characters',
    lastNameRequiredValidation: 'Last name is required',
    emailInvalid: 'Invalid email format',
    emailRequiredValidation: 'Email is required',
    phoneInvalid: 'Invalid phone number format',
    mobileInvalid: 'Invalid phone number format',
    peselInvalid: 'PESEL must have 11 digits',
    nipInvalid: 'NIP must have 10 digits',
    ibanInvalid: 'Invalid IBAN format'
  }
}

export type Language = 'pl' | 'en'
export type TranslationKey = keyof typeof clientFormTranslations.pl
